import React from 'react';

function ZoomIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
      <path d="M19.56,17.38,15.5,13.32a8.5,8.5,0,1,0-2.18,2.18l4.06,4a1.41,1.41,0,0,0,1.08.46A1.57,1.57,0,0,0,20,18.46,1.5,1.5,0,0,0,19.56,17.38ZM8.5,14A5.5,5.5,0,1,1,14,8.5,5.5,5.5,0,0,1,8.5,14Z" />
    </svg>
  );
}

export default ZoomIcon;
